import type { FormProps } from '../../types'
import cx from 'classnames'
import style from '../form.module.css'

export interface RadioGroupGenderInput {
  name: string
  type: string
  customControlType: 'radioGroupGender'
  value: string
  validations?: string[]
  uiOptions?: {
    testId?: string
  }
}

export default function RadioGroupGender({
  field,
  formProps,
}: {
  field: RadioGroupGenderInput
  formProps: FormProps
}) {
  const currentValue = formProps.formValues[field.name]

  return (
    <>
      <div className="flex flex-row gap-4 pl-1.5 pt-4">
        <label
          htmlFor={`${field.name}-man`}
          className={cx(
            style.radioGender,
            'radioGenderClient', 'bg-background-light',
            currentValue === 'man' && 'border-primary bg-primary text-primary-foreground',
          )}
          data-testid={`${field.uiOptions?.testId ?? field.name}-man`}
        >
          <input
            {...formProps.register(field.name, {
              required: field.validations?.includes('required'),
            })}
            type="radio"
            value="man"
            className="sr-only"
            id={`${field.name}-man`}
            data-testid={`${field.uiOptions?.testId ?? field.name}-man-input`}
          />
          <span className="font-bold text-slate-50">{'Man'}</span>
        </label>
        <label
          htmlFor={`${field.name}-woman`}
          className={cx(
            style.radioGender,
            'radioGenderClient', 'bg-background-light text-slate-50',
            currentValue === 'woman' && 'border-primary bg-primary text-primary-foreground',)}
          data-testid={`${field.uiOptions?.testId ?? field.name}-woman`}
        >
          <input
            {...formProps.register(field.name, {
              required: field.validations?.includes('required'),
            })}
            type="radio"
            value="woman"
            className="sr-only"
            id={`${field.name}-woman`}
            data-testid={`${field.uiOptions?.testId ?? field.name}-woman-input`}
          />
          <span className="font-bold text-slate-50">{'Vrouw'}</span>
        </label>
        <label
          htmlFor={`${field.name}-different`}
          className={cx(
            style.radioGender,
            'radioGenderClient', 'bg-background-light text-slate-50',
            currentValue === 'different' && 'border-primary bg-primary text-primary-foreground',
          )}
          data-testid={`${field.uiOptions?.testId ?? field.name}-different`}
        >
          <input
            {...formProps.register(field.name, {
              required: field.validations?.includes('required'),
            })}
            type="radio"
            value="different"
            className="sr-only"
            id={`${field.name}-different`}
            data-testid={`${field.uiOptions?.testId ?? field.name
              }-different-input`}
          />
          <span className="font-bold text-slate-50">{'Anders'}</span>
        </label>
      </div>
    </>
  )
}
